import React from 'react';
import { ChevronDown } from 'react-feather';
import { cx } from './cx';

interface DisclosureProps {
  summary: React.ReactNode;
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

/** Expandable list row: a summary line that opens a detail panel. Keyboard and screen-reader friendly. */
const Disclosure: React.FC<DisclosureProps> = ({ summary, open, onToggle, children }) => {
  const panelId = React.useId();
  return (
    <div className={cx('ds-disclosure', open && 'ds-disclosure--open')}>
      <button type="button" className="ds-disclosure__trigger" aria-expanded={open} aria-controls={panelId} onClick={onToggle}>
        <div className="ds-disclosure__summary">{summary}</div>
        <span className="ds-disclosure__chevron"><ChevronDown size={18} aria-hidden /></span>
      </button>
      {open && (
        <div id={panelId} className="ds-disclosure__panel">
          {children}
        </div>
      )}
    </div>
  );
};

export default Disclosure;
